export const TRY_SEND_LOGS = 'clientLog/TRY_SEND_LOGS';
